// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

export class Id {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): Id {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  site(): number {
    return this.bb!.readUint16(this.bb_pos)
  }

  timestamp(): number {
    return this.bb!.readUint32(this.bb_pos + 4)
  }

  static sizeOf(): number {
    return 8
  }

  static createId(builder: flatbuffers.Builder, site: number, timestamp: number): flatbuffers.Offset {
    builder.prep(4, 8)
    builder.writeInt32(timestamp)
    builder.pad(2)
    builder.writeInt16(site)
    return builder.offset()
  }
}
